import { useEffect, useState } from "react";
import { Tab } from "../../../stores/TabsStore";
import { DateTime } from "luxon";
import { ReportProvider } from "./ReportContext";
import Spinner from "../../../ui/Spinner/Spinner";
import ReportForm from "./ReportForm";
import TableView from "./ReportTable";
import ReportGraph from "./ReportGrpah";
import { ReportCalendar } from "./ReportCalendar";

export function PersonsReport({tab}:{tab: Tab}) {
  let personsAmount = tab.defaultValues?.persons?.length!;
  let shiftAmount = tab.defaultValues?.shifts?.length!;
  let daysAmount =
  tab.defaultValues?.period_type === "static"
    ? DateTime.fromISO(tab.defaultValues?.dates?.to?.toISOString()!)
        .diff(DateTime.fromISO(tab.defaultValues?.dates?.from?.toISOString()!), "days")
        .toObject().days! + 1
    : tab.defaultValues?.dynamic_period!;

  let maxLoadTime = 2 * personsAmount * daysAmount * shiftAmount;
  const [estimatedLoadTime, setEstimatedLoadTime] = useState(0);
  const [isEstimatedTimeReady, setIsEstimatedTimeReady] = useState(false);

  const [processedData, setProcessedData] = useState(0);

  const addProcessedData = (value: number) => {
    setProcessedData(processedData + value);
    setEstimatedLoadTime(
      maxLoadTime - (maxLoadTime * (processedData + value)) / (personsAmount * shiftAmount)
    );
  };

  // Показ приблизительного времени через 10 секунд
  useEffect(() => {
    if (tab.dataIsLoading)
      setTimeout(() => {
        setEstimatedLoadTime(2 * personsAmount * daysAmount * shiftAmount);
        setProcessedData(0);
        setIsEstimatedTimeReady(true);
      }, 10000);
    else setIsEstimatedTimeReady(false);
  }, [tab.dataIsLoading]);

  

  function getTabContent(tab: Tab) {
    switch (tab.view) {
      case "table":
        return <TableView tab={tab}/>;
      case "report":
        return <ReportGraph tab={tab} />;
      case "calendar":
        return <ReportCalendar tab={tab} />;
      case "settings":
        return <ReportForm tab={tab} />;
      default:
        return <></>;
    }
  }

  return (
    <ReportProvider tab={tab} addProcessedData={addProcessedData}>
      {tab.dataIsLoading ? (
        <div>
          <Spinner />
          <div className="flex items-center justify-center h-full w-full">
            {isEstimatedTimeReady
              ? `Примерное время ожидания загрузки данных для отчёта: ${Math.round(estimatedLoadTime / 60)} минут.
              Загружено ${Math.round((processedData / (personsAmount * shiftAmount)) * 100)}%`
              : `Идёт расчёт времени ожидания`}
          </div>
        </div>
      ) : tab?.options ? (
        <div className="relative flex w-full h-full">
          <div className="relative flex flex-col w-full h-full overflow-hidden">{getTabContent(tab)}</div>
        </div>
      ) : (
        <ReportForm tab={tab} />
      )}
    </ReportProvider>
  )
}